import dayjs from "dayjs";
import * as XLSX from "xlsx";

import { kardexService } from "./kardexService";
import { movementsService } from "./movementsService";
import {
  applyUnifiedClientFilters,
  buildUnifiedRows,
  UNIFIED_KIND_LABELS,
  type UnifiedKardexFilters,
} from "./unifiedKardex";

/**
 * Export the unified Kardex (products + ingredients + oils) to a single sheet.
 * Mirrors exactly what the screen shows for the same filters.
 */
export const exportUnifiedKardexToExcel = async (
  filters: UnifiedKardexFilters
): Promise<void> => {
  const serverFilters = {
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    userId: filters.userId,
    search: filters.search,
  };

  const [kardexRows, ingredientRows] = await Promise.all([
    kardexService.getKardex(serverFilters),
    movementsService.getIngredientMovements(serverFilters),
  ]);

  const rows = applyUnifiedClientFilters(
    buildUnifiedRows(kardexRows, ingredientRows),
    filters
  ).sort((a, b) => b.fechaSort - a.fechaSort);

  const excelData = rows.map((r) => ({
    Fecha: r.fecha,
    Tipo: UNIFIED_KIND_LABELS[r.kind],
    Código: r.codigo ?? "—",
    Ítem: r.item ?? "—",
    Movimiento: r.movimiento,
    Ubicación: r.ubicacion ?? "—",
    Entrada: r.entrada ?? "",
    Salida: r.salida ?? "",
    Saldo: r.saldo ?? "—",
    UM: r.um ?? "—",
    "Costo Unitario": r.costoUnitario ?? "",
    "Costo Total": r.costoTotal ?? "",
    Referencia: r.referencia ?? "—",
    Usuario: r.usuario ?? "Sistema",
  }));

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  worksheet["!cols"] = [
    { wch: 16 }, // Fecha
    { wch: 10 }, // Tipo
    { wch: 15 }, // Código
    { wch: 35 }, // Ítem
    { wch: 18 }, // Movimiento
    { wch: 10 }, // Ubicación
    { wch: 12 }, // Entrada
    { wch: 12 }, // Salida
    { wch: 12 }, // Saldo
    { wch: 8 }, // UM
    { wch: 14 }, // Costo Unitario
    { wch: 14 }, // Costo Total
    { wch: 24 }, // Referencia
    { wch: 20 }, // Usuario
  ];

  XLSX.utils.book_append_sheet(workbook, worksheet, "Kardex");
  XLSX.writeFile(workbook, `kardex_${dayjs().format("YYYY-MM-DD")}.xlsx`);
};
